<mat-card style="border-color: #5775a8;">
  <mat-card-content>

    <br />
    <mat-card>
      <div class="flex flex-col w-full items-center">
        <div class="flex flex-row w-1/2">
          <a style="display: flex; align-items: center; justify-content: center;padding-right: 20px;" (click)="gotoEdit()"><mat-icon>edit</mat-icon> Edit</a>
          <a style="display: flex; align-items: center; justify-content: center;"><mat-icon>refresh</mat-icon> Refresh</a>
        </div>
        <br />
        <div class="flex flex-row rounded-lg w-11/12">
          <table class="w-full">
            <tr style="padding-bottom: 10px;">
              <th>Complaint ID:</th>
              <td>{{currentComplaint.complaintId}} </td>
              <th>Business Type: </th>
              <td>
                {{businessType(currentComplaint.typeOfBusiness)}}
              </td>
            </tr>
            <tr>
              <th>Date Submitted:</th>
              <td>
                {{currentComplaint.complaintDate}}
              </td>
              <th>Business Status:</th>
              <td>
                <span *ngIf="currentComplaint.businessActive" style="color: green;">Active</span>
                <span *ngIf="!currentComplaint.businessActive" style="color: red;">Inactive</span>
              </td>
            </tr>
            <tr>
              <th>Actionable:</th>
              <td>
                {{currentComplaint.actionable? 'Yes': 'No'}}
              </td>
              <th>Business Information:</th>
              <td>
                {{currentComplaint.businessName}}
                <br />
                {{currentComplaint.address}}
                <br />
                {{currentComplaint.city}}, OR {{currentComplaint.zip}}
                <br />
                {{currentComplaint.businessPhone}}
              </td>
            </tr>
            <tr>
              <th>{{currentComplaint.actionable? 'Nature of Complaint' :'Reason Non-Actionable:'}}</th>
              <td>
                <div *ngIf="currentComplaint.actionable">
                  <span *ngFor="let list of currentComplaint.selectedNatureOfComplaints">
                    {{list}}<br />
                  </span>
                </div>
                <span *ngIf="!currentComplaint.actionable">{{currentComplaint.reasonNonActionable}}</span>

              </td>
              <th>Business County:</th>
              <td>
                {{currentComplaint.county}}
              </td>
            </tr>
            <tr>
              <th>Complaint Status:</th>
              <td>
                {{currentComplaint.complaintStatus}}
              </td>
              <th>Complaint Information:</th>
              <td>
                <div *ngIf="initialComplaint.contactEmail != null && initialComplaint.contactName.length > 0">
                  {{initialComplaint.contactName}}<br />
                  {{initialComplaint.contactEmail}}<br />
                </div>
                <div *ngIf="initialComplaint.contactAddress != null && initialComplaint.contactName.length > 0">
                  {{initialComplaint.contactName}}<br />
                  {{initialComplaint.contactAddress}}<br />
                  {{initialComplaint.contactCity}}, {{initialComplaint.contactState}}
                  {{initialComplaint.contactZip}}<br />
                </div>
              </td>
            </tr>
            <tr>
              <th colspan="2">Business Contact:</th>
              <th colspan="2">Complaint Text:</th>
            </tr>
            <tr>
              <td colspan="2">
                {{currentComplaint.businessContactName}}<br />
                {{currentComplaint.businessContactPhone}}<br />
                {{currentComplaint.businessContactEmail}}<br />
              </td>
              <td colspan="2">
                {{currentComplaint.complaintComments}}
              </td>
            </tr>

          </table>

        </div>
        <br />
      </div>

    </mat-card>
    <br />

  </mat-card-content>

</mat-card>